import { render, staticRenderFns } from "./UsiMappingDetailsPage.vue?vue&type=template&id=50b7d2a8&"
import script from "./UsiMappingDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./UsiMappingDetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports